import logo from 'Assets/unixi_logo.png';
import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import { CircularProgress } from 'Components/UI';

import { useLoginMagicLinkConfirm } from 'Services/LoginAPI';
import { useAuthenticate } from "Services/Authentication";
import styles from './LoginForm.module.css';

export default function MagicLinkCheck({ magicLink, animateGlobe, setAnimateGlobe }) {
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        DoSet();
    }, []);

    function DoSet() {
        useLoginMagicLinkConfirm(magicLink)
            .then((response) => {
                if (response?.status) {
                    if (response.status === true) {
                        setTimeout(() => CompleteLogin(response), 300);
                        return;
                    }
                } 
                toast.error(response?.message);
                setLoading(false);
                setTimeout(() => navigate('/login'), 3000);
            })
            .catch((error) => {
                toast.error(error.toString());
                console.log(error);
            });
    }

  function CompleteLogin(response) {
    useAuthenticate(response.user, response.tenant);
    const LandingPage = response.tenant.landing_page;
    animateGlobe?.animation();

    setTimeout(() => CompleteLogin2(LandingPage), 2000, response);
  }

  function CompleteLogin2(LandingPage) {
    const redirectPath = localStorage.getItem("redirectPath") || "/";

    localStorage.removeItem("redirectPath"); // Clear the saved path
    if (redirectPath === "/") {
      window.location.href = LandingPage
        ? `/unixi-management-portal/app/${LandingPage}`
        : "/unixi-management-portal/app/dashboard";
    } else if (redirectPath.startsWith("/unixi-management-portal")) {
      window.location.href = `${redirectPath}`;
    } else {
      window.location.href = `/unixi-management-portal${redirectPath}`;
    }
  }

    return (
        <div className={styles.container}>
            <br />
            <img src={logo} className={styles.logo} alt='logo' />
            <br />
            <div className={styles.loginMessageMfa}>
                <div className={styles.errorMessage}> </div>
            </div>
            <br />

            
            <form className={styles.form}>
                <CircularProgress color="primary" hidden={!loading} size={60} />

                <div className={styles.login_message}>
                    { loading ? 'Confirming magic link...' : 'Magic link invalid!' }
                </div>
            </form>
            <div className={styles.linkHolder}>
                <Link to='/login' className={styles.link}>
                    Back to Login
                </Link>
            </div>
        </div>
    );
}
